import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/beanie_256.png'
import _imports_1 from '@/assets/icons/mail_open_gray_60.png'
import _imports_2 from '@/assets/icons/everyone_500.png'
import _imports_3 from '@/assets/icons/person_gray_150.png'
import _imports_4 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-c7a21b10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-users-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Manage users", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "User ID", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Subject", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Email", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Location", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Joined", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "OS", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Trees", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Sync", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Sharing", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Plan", -1))
const _hoisted_16 = { class: "grid-cell mono dim" }
const _hoisted_17 = { class: "grid-cell mono dim" }
const _hoisted_18 = { class: "grid-cell type" }
const _hoisted_19 = {
  key: 0,
  src: _imports_0,
  class: "supers"
}
const _hoisted_20 = {
  key: 1,
  src: _imports_1,
  class: "invited"
}
const _hoisted_21 = { class: "grid-cell name" }
const _hoisted_22 = { class: "grid-cell" }
const _hoisted_23 = { class: "grid-cell" }
const _hoisted_24 = { class: "grid-cell date" }
const _hoisted_25 = { class: "grid-cell dim" }
const _hoisted_26 = { class: "grid-cell devices" }
const _hoisted_27 = ["src", "title", "alt"]
const _hoisted_28 = { class: "grid-cell rgs" }
const _hoisted_29 = { class: "list-unstyled" }
const _hoisted_30 = ["src", "title", "alt"]
const _hoisted_31 = { class: "grid-cell sharing" }
const _hoisted_32 = {
  key: 0,
  class: "groups"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "users"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_36 = {
  key: 2,
  class: "invites"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_38 = {
  key: 0,
  class: "badge badge-xs"
}

import { ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { subscriptionPlans, User, UserSort } from '@/gp/GroupAdminModel'
import { SyncState } from '@/rd/ResearchDataModel'
import { DateTime } from 'luxon'
import { DurationUtil } from '@/util/LuxonUtil'
import { isDefined } from '@/util/TypeScriptUtil'
import PaginatedListView from '@/util/PaginatedListView.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageUsersPage',
  setup(__props) {

const sortOptions = [
  { value: UserSort.CreatedDate, label: 'Newest' },
  { value: UserSort.Surname, label: 'Last name' },
  { value: UserSort.GivenName, label: 'First name' },
]

const sortRef = ref(UserSort.CreatedDate)

const userStore = useUserStore()
const subscriptionStore = useSubscriptionStore()

async function fetchPage(options: { search?: string; sort: UserSort; pageSize: number; next?: string; }) {
  sortRef.value = options.sort
  return await userStore.searchUsersAsync({
    name: options.search,
    sort: options.sort,
    pageSize: options.pageSize,
    next: options.next
  })
}

function getDisplayName(u: User) {
  return sortRef.value === UserSort.Surname
    ? [u.surname, u.givenName].filter(isDefined).join(', ')
    : [u.givenName, u.surname].filter(isDefined).join(' ')
}

function toDateText(dt?: DateTime) {
  return dt?.toLocal().toFormat('yyyy-MM-dd')
}

function toAgeText(dt?: DateTime) {
  return dt ? DurationUtil.toAge(dt.diffNow().negate()) : ''
}

function getUsage(u: User) {
  return userStore.asyncUsage.get(u.id!)?.data
}


function getPlan(u: User) {
  var subs = subscriptionStore.getSubscriptionListForUser(u.id)
  return subscriptionPlans.find(p => p.id == subs.at(0)?.items.at(0)?.price?.productId)
}

function hasSupervisors(u: User) {
  const keyList = userStore.asyncSupervisorKeys.get(u.id!)?.data
  return keyList && keyList.keys.length > 0
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PaginatedListView, {
      fetchPage: fetchPage,
      getRowKey: (u) => u.userId!,
      sortOptions: sortOptions,
      searchPlaceholder: "Search for a name, address, or user ID",
      showSearch: true,
      pageSize: 25
    }, {
      header: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15
      ]),
      row: _withCtx(({ item: u }: { item: User }) => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, {
            to: u.pageUrl
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(u.id), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(u.subject), 1),
        _createElementVNode("div", _hoisted_18, [
          (hasSupervisors(u))
            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
            : (u.invited)
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_router_link, {
            to: u.pageUrl
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getDisplayName(u)), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _createElementVNode("div", _hoisted_22, _toDisplayString(u.email), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(u.metadata?.location), 1),
        _createElementVNode("div", _hoisted_24, _toDisplayString(toDateText(u.createdDate)), 1),
        _createElementVNode("div", _hoisted_25, _toDisplayString(toAgeText(u.createdDate)), 1),
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUsage(u)?.syncOSInfos ?? [], (os) => {
            return (_openBlock(), _createElementBlock("img", {
              key: os.id,
              src: os.icon,
              title: os.name,
              alt: os.name,
              class: _normalizeClass(os.id)
            }, null, 10, _hoisted_27))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("ul", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUsage(u)?.workspaceBaseTypes ?? [], ({ type: t, count }) => {
              return (_openBlock(), _createElementBlock("li", {
                key: t.id
              }, [
                _createElementVNode("img", {
                  src: t.icon,
                  title: t.product,
                  alt: t.product
                }, null, 8, _hoisted_30),
                (count > 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(count), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["grid-cell sync", { failed: getUsage(u)?.lastSyncState != _unref(SyncState).Completed }])
        }, _toDisplayString(toAgeText(getUsage(u)?.lastSyncDate)), 3),
        _createElementVNode("div", _hoisted_31, [
          (getUsage(u)?.totalFamilyGroups)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                _hoisted_33,
                _createTextVNode(" " + _toDisplayString(getUsage(u)?.totalFamilyGroups), 1)
              ]))
            : _createCommentVNode("", true),
          (getUsage(u)?.sharingUsers)
            ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                _hoisted_35,
                _createTextVNode(" " + _toDisplayString(getUsage(u)?.sharingUsers), 1)
              ]))
            : _createCommentVNode("", true),
          (getUsage(u)?.sharingInvites)
            ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                _hoisted_37,
                _createTextVNode(" " + _toDisplayString(getUsage(u)?.sharingInvites), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["grid-cell plan", getPlan(u)?.baseType])
        }, [
          (getPlan(u))
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(getPlan(u)?.displayName), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["getRowKey"])
  ]))
}
}

})